import React from 'react';
import { XCircle, TrendingDown, Clock, Smartphone } from 'lucide-react';
export function Problem() {
  return <section className="bg-navy-900 px-4 py-16 sm:px-6 lg:px-8 lg:py-24" data-id="element-166">
      <div className="mx-auto max-w-4xl" data-id="element-167">
        <div className="mb-16 text-center" data-id="element-168">
          <h2 className="mb-6 text-4xl sm:text-5xl font-bebas text-white" data-id="element-169">
            El Castigo Diario del{' '}
            <span className="text-red-400" data-id="element-170">Mal Crédito</span>
          </h2>
          <p className="text-xl text-slate-300 max-w-2xl mx-auto" data-id="element-171">
            En Estados Unidos, vivir con mal crédito es un castigo diario. Pagas
            el doble en intereses de auto, te niegan el alquiler del apartamento
            que deseas y el sueño de tener casa propia parece una fantasía
            lejana.
          </p>
        </div>

        <div className="mb-16 rounded-2xl bg-navy-800 p-8 border border-slate-700/50 shadow-xl" data-id="element-172">
          <h3 className="mb-4 text-2xl font-bebas text-gold-400" data-id="element-173">
            La Trampa de las "Agencias de Reparación"
          </h3>
          <p className="text-lg text-slate-300" data-id="element-174">
            Lo peor es que las famosas "agencias de reparación" te cobran
            mensualidades de $99 para enviar una sola carta al mes, estirando el
            proceso durante un año para sacarte todo el dinero posible. Mientras
            tanto, tu vida sigue estancada porque una computadora en Experian
            decidió que "no eres confiable".
          </p>
        </div>

        <h3 className="mb-8 text-center text-3xl font-bebas text-white" data-id="element-175">
          Por qué lo que has intentado{' '}
          <span className="text-red-400" data-id="element-176">NO FUNCIONÓ</span>
        </h3>

        <div className="grid gap-6 sm:grid-cols-3" data-id="element-177">
          <div className="rounded-xl bg-navy-800 p-6 border border-slate-700/50 hover:border-red-500/30 transition-colors" data-id="element-178">
            <Smartphone className="mb-4 h-8 w-8 text-slate-400" data-id="element-179" />
            <h4 className="mb-2 text-xl font-bold text-white" data-id="element-180">
              Apps Gratuitas
            </h4>
            <p className="text-slate-400" data-id="element-181">
              Las aplicaciones como Credit Karma solo sirven para mirar el
              desastre, pero no tienen herramientas legales para repararlo.
            </p>
          </div>

          <div className="rounded-xl bg-navy-800 p-6 border border-slate-700/50 hover:border-red-500/30 transition-colors" data-id="element-182">
            <Clock className="mb-4 h-8 w-8 text-slate-400" data-id="element-183" />
            <h4 className="mb-2 text-xl font-bold text-white" data-id="element-184">
              Ignorar el Problema
            </h4>
            <p className="text-slate-400" data-id="element-185">
              No hace que las deudas desaparezcan; los burós a menudo venden tu
              información y los errores se multiplican con los años.
            </p>
          </div>

          <div className="rounded-xl bg-navy-800 p-6 border border-slate-700/50 hover:border-red-500/30 transition-colors" data-id="element-186">
            <TrendingDown className="mb-4 h-8 w-8 text-slate-400" data-id="element-187" />
            <h4 className="mb-2 text-xl font-bold text-white" data-id="element-188">
              Pagar a Ciegas
            </h4>
            <p className="text-slate-400" data-id="element-189">
              Pagar deudas viejas por tu cuenta sin estrategia puede bajar más
              tu puntaje al "despertar" la actividad de la cuenta.
            </p>
          </div>
        </div>
      </div>
    </section>;
}